import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../../lib/net";

import Ff_Input from "../../../lib/ui/ff_input";
import PdfRpDlg from "../fkn/pdf_rp_dlg";
import Fortnox_Logg from "./fortnox_logg";

class Fortnox_Wnd extends React.Component {
  constructor(props, context) {
    super(props);

    this.store = props.store;
    this.state = {};
    this.state.cols = {};

    this.state.ix = 0;
    this.state.plu = "";
    this.state.text = "";
    this.state.pris = "";
    this.state.wnds = {};

    this.state.syo = {};
    this.state.syo.if = {};
    this.state.syo.if.fortnox = {};
    this.state.tra = [];
    if(props.wnds) {
        this.state.tra = Object.values(this.state.dto.nts);
    }

    this.state.pdf = 0;
    this.state.pdf_content = null;
    //alert('BRA: ' + JSON.stringify(this.state.bra));
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.fx_info();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
  tb_style() {
      var css = {};
      css.height = (window.innerHeight * 0.9) - 150;
      css.overflow = "auto";
      return css;
  }

    wnd_close = () => {
		this.props.ctx.setState({ wnds: {} });
		this.props.ctx.setState({ rptyp: "" });
	};

  pdf_done (ret) {
    this.setState({loading: 0, pdf: 0, pdf_content: null });
  }

    fx_info() {
          var self = this;
  
          var prm = {};
          prm.req = "sys.sid.sid";
          prm.avd = this.state.avd;
  
          net.sio_req(prm)
          .then(function(ret){
              //alert(JSON.stringify(ret.rco));
  
              var syo = ret.rco;
              if(syo == "") return;
              //alert( Object.keys(syo.if.fortnox) );
              self.setState({ syo: syo });
          })
          .catch(function(e){
              var txt = JSON.stringify(e);
          });
      }
  

    fx_logg() {
      var self = this;
      var wnds = {};
      wnds.fxlogg = true;
      self.setState({ wnds: wnds });
    }

render() {

	var html =
        <div className="mx_base">
        { this.props.backdrop ? <div className="mx_backdrop" /> : null }
        <div className="mx_dlg mx_90 flex-col" style={ this.dlg_style() }>

        <div className="mx_content flex">
            <div className="flex-row" style={{padding:"5px",height:"30px"}}>
                    <div className="flex-row txt_18">
                        <div>FORTNOX</div>
                    </div>
                    <div className="flex-row flex txt_18">
                    </div>
            </div>
            <div className="divider_orange"></div>

            <div className="flex-row">
              <div className="flex"></div>
              <div className="web-link txt_16 px-2" onClick={() => this.fx_data() }>Uppdatera</div>
            </div>

            <div className="divider_orange"></div>

            <div className="flex-col flex-cc flex">

            <div className="flex-col">
            <div className="flex-row">
            <div className="cdi_val_box w350">
                <label>Sid</label>
                <input type="text" placeholder="" value={ this.state.syo.sid } style={{ "border":"0px solid #000" }} onChange={(event) => this.handleUserInput(event)} required />
            </div>
            <div className="cdi_val_box w450">
                <label>Text</label>
                <input type="text" placeholder="" value={ this.state.syo.text } style={{ "border":"0px solid #000" }} onChange={(event) => this.handleUserInput(event)} required />
            </div>
            </div>

            <div className="flex-row">
            <div className="cdi_val_box w350">
                <label>Registrerad</label>
                <input type="text" placeholder="" value={ this.state.syo.if.fortnox.reg } style={{ "border":"0px solid #000" }} onChange={(event) => this.handleUserInput(event)} required />
            </div>
            <div className="cdi_val_box w450">
            </div>
            </div>

            <div className="flex-row">
            <div className="cdi_val_box w350">
                <label>Access Valid</label>
                <input type="text" placeholder="" value={ this.state.syo.if.fortnox.access_valid } style={{ "border":"0px solid #000" }} onChange={(event) => this.handleUserInput(event)} required />
            </div>
            <div className="cdi_val_box w450">
                <label>Access Token</label>
                <input type="text" placeholder="" value={ this.state.syo.if.fortnox.access_token } style={{ "border":"0px solid #000" }} onChange={(event) => this.handleUserInput(event)} required />
            </div>
            </div>

            <div className="flex-row">
            <div className="cdi_val_box w350">
                <label>Refresh Valid</label>
                <input type="text" placeholder="" value={ this.state.syo.if.fortnox.refresh_valid } style={{ "border":"0px solid #000" }} onChange={(event) => this.handleUserInput(event)} required />
            </div>
            <div className="cdi_val_box w450">
                <label>Refresh Token</label>
                <input type="text" placeholder="" value={ this.state.syo.if.fortnox.refresh_token } style={{ "border":"0px solid #000" }} onChange={(event) => this.handleUserInput(event)} required />
            </div>
            </div>
            <div className="flex-row">
            <div className="cdi_val_box w350">
                <label>Token</label>
                <input type="text" placeholder="" value={ this.state.syo.if.fortnox.token } style={{ "border":"0px solid #000" }} onChange={(event) => this.handleUserInput(event)} required />
            </div>
            <div className="cdi_val_box w450">
                <label>Refresh Token</label>
                <input type="text" placeholder="" value={ this.state.syo.if.fortnox.refreshtoken } style={{ "border":"0px solid #000" }} onChange={(event) => this.handleUserInput(event)} required />
            </div>
            </div>

            </div>
            </div>

        </div>

        <div className="divider_blue"></div>
        <div className="flex-row">
            <div className="web-link txt_16 px-2" onClick={() => this.fortnox_reg() }>Registrera Fortnox</div>
            <div className="flex"></div>
            <div className="web-link txt_16 px-2" onClick={() => this.fortnox_auto() }>Fortnox Överför</div>
        </div>

        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex"></div>
            <button className="btn btn-hw-blue w250" onClick={(event) => this.fx_logg(event) } >
                LOGG
            </button>
            <div className="flex"></div>
            <button className="btn btn-hw-green w250" onClick={(event) => this.prn_copy(event) } >
                SKRIV UT
            </button>
            
        </div>
      </div>

      { this.state.wnds.fxlogg ? <Fortnox_Logg wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
      <PdfRpDlg show={this.state.pdf} pdf={this.state.pdf_content} done={(ret) => this.pdf_done(ret)} backdrop={true}/>
      </div>
	;
	return html;
  };
}

export default Fortnox_Wnd;